
















import mixins from '../../mixins';
import validatable from '../../mixins/validatable/validatable';
import PScaleTransition from '../p-transition/p-scale-transition.vue';
import PSlideYTransition from '../p-transition/p-slide-y-transition.vue';
import pFormElementMessages from './p-form-element-messages.vue';

export default mixins(validatable).extend({
  components: { pFormElementMessages, PSlideYTransition, PScaleTransition },
  props: {
    showMessages: { default: false, type: Boolean },
  },
  computed: {
    classList(): Record<string, boolean> {
      return {
        'p-form-element': true,
        invalid: (this.innerErrors ?? []).length > 0,
      };
    },
  },
});
